module.exports = require("defclass");


//////////////////
// WEBPACK FOOTER
// external "defclass"
// module id = 0
// module chunks = 0